import React, { useEffect, useState } from 'react';
const INITIAL_COPIES = 985;
const MIN_COPIES = 30;
const STORAGE_KEY = 'bttf_copies_available';
export const CopiesAvailableCounter = () => {
  const [copiesAvailable, setCopiesAvailable] = useState(() => {
    if (typeof window === 'undefined') return INITIAL_COPIES;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : INITIAL_COPIES;
  });
  useEffect(() => {
    // Initialize localStorage if not set
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, INITIAL_COPIES.toString());
    }
    const decrementCopies = () => {
      setCopiesAvailable(prev => {
        if (prev <= MIN_COPIES) return prev;
        const decrease = Math.floor(Math.random() * 3) + 1;
        const newValue = Math.max(MIN_COPIES, prev - decrease);
        localStorage.setItem(STORAGE_KEY, newValue.toString());
        window.dispatchEvent(new CustomEvent('copiesUpdated', {
          detail: newValue
        }));
        return newValue;
      });
    };
    const handleCopiesUpdate = (event: CustomEvent) => {
      setCopiesAvailable(event.detail);
    };
    window.addEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setCopiesAvailable(parseInt(e.newValue, 10));
      }
    };
    window.addEventListener('storage', handleStorageChange);
    const getRandomInterval = () => Math.floor(Math.random() * 2000) + 2000;
    let timeoutId: NodeJS.Timeout;
    const scheduleNextDecrement = () => {
      timeoutId = setTimeout(() => {
        decrementCopies();
        scheduleNextDecrement();
      }, getRandomInterval());
    };
    scheduleNextDecrement();
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return <div className="w-[90%] md:w-auto inline-flex flex-col items-center gap-2 md:gap-3 bg-gradient-christmas text-white font-bold px-6 py-4 md:px-10 md:py-5 lg:px-12 lg:py-6 rounded-lg shadow-christmas-glow animate-pulse border-2 border-christmas-gold/50" data-id="element-107">
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 md:gap-3" data-id="element-108">
        <span className="text-xl md:text-2xl lg:text-3xl" data-id="element-109">🎄</span>
        <span className="text-2xl md:text-3xl lg:text-4xl tabular-nums font-extrabold" data-id="element-110">
          LIMITED CHRISTMAS EDITION
        </span>
        <span className="text-xl md:text-2xl lg:text-3xl" data-id="element-111">🎁</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 md:gap-3" data-id="element-112">
        <span className="text-base md:text-xl lg:text-2xl uppercase tracking-wider" data-id="element-113">
          ONLY
        </span>
        <span className="text-4xl md:text-4xl lg:text-5xl tabular-nums transition-all duration-300 font-extrabold text-christmas-gold" data-id="element-114">
          {copiesAvailable.toLocaleString()}
        </span>
        <span className="text-base md:text-xl lg:text-2xl uppercase tracking-wider" data-id="element-115">
          LEFT
        </span>
      </div>
      <div className="text-sm md:text-base text-christmas-gold animate-twinkle" data-id="element-116">
        ⭐ Perfect Holiday Gift ⭐
      </div>
    </div>;
};